const copy = {
  en: {
    generic: 'Something went wrong. Please try again.',
    permission: 'Your account does not have permission to complete this action.',
    authentication: 'Please sign in again to continue.',
    network: 'The connection was interrupted. Check your internet connection and try again.',
    notFound: 'The requested information could not be found.',
    storage: 'The file could not be uploaded. Check your connection and try again.',
    invalidCredential: 'The email or password is incorrect.',
    accountNotFound: 'No Fate Room account was found for this email.',
    emailInUse: 'This email already has an account. Log in instead.',
    weakPassword: 'Choose a password with at least 8 characters.',
    popupClosed: 'Google sign-in was closed before it finished.',
    popupBusy: 'Only one Google sign-in window can be open at a time.',
    popupBlocked: 'Your browser blocked the Google sign-in window. Allow popups and try again.',
    unauthorizedDomain: 'Google sign-in is not enabled for this web address yet.',
    providerDisabled: 'This sign-in method is not enabled for Fate Room yet.',
    accountConflict: 'This email already uses another login method. Log in with your password first.',
  },
  sk: {
    generic: 'Niečo sa nepodarilo. Skúste to znova.',
    permission: 'Váš účet nemá oprávnenie vykonať túto akciu.',
    authentication: 'Ak chcete pokračovať, prihláste sa znova.',
    network: 'Spojenie bolo prerušené. Skontrolujte internetové pripojenie a skúste to znova.',
    notFound: 'Požadované informácie sa nenašli.',
    storage: 'Súbor sa nepodarilo nahrať. Skontrolujte pripojenie a skúste to znova.',
    invalidCredential: 'E-mail alebo heslo nie sú správne.',
    accountNotFound: 'Pre tento e-mail sa nenašiel účet Fate Room.',
    emailInUse: 'Tento e-mail už má účet. Namiesto registrácie sa prihláste.',
    weakPassword: 'Vyberte heslo s najmenej 8 znakmi.',
    popupClosed: 'Prihlásenie cez Google bolo zatvorené pred dokončením.',
    popupBusy: 'Naraz môže byť otvorené iba jedno okno prihlásenia cez Google.',
    popupBlocked: 'Prehliadač zablokoval okno Google. Povoľte vyskakovacie okná a skúste to znova.',
    unauthorizedDomain: 'Prihlásenie cez Google zatiaľ nie je povolené pre túto webovú adresu.',
    providerDisabled: 'Tento spôsob prihlásenia zatiaľ nie je vo Fate Room povolený.',
    accountConflict: 'Tento e-mail už používa iný spôsob prihlásenia. Najprv sa prihláste heslom.',
  },
  cs: {
    generic: 'Něco se nepodařilo. Zkuste to znovu.',
    permission: 'Váš účet nemá oprávnění provést tuto akci.',
    authentication: 'Chcete-li pokračovat, přihlaste se znovu.',
    network: 'Spojení bylo přerušeno. Zkontrolujte připojení k internetu a zkuste to znovu.',
    notFound: 'Požadované informace nebyly nalezeny.',
    storage: 'Soubor se nepodařilo nahrát. Zkontrolujte připojení a zkuste to znovu.',
    invalidCredential: 'E-mail nebo heslo nejsou správné.',
    accountNotFound: 'Pro tento e-mail nebyl nalezen účet Fate Room.',
    emailInUse: 'Tento e-mail už má účet. Místo registrace se přihlaste.',
    weakPassword: 'Zvolte heslo s nejméně 8 znaky.',
    popupClosed: 'Přihlášení přes Google bylo zavřeno před dokončením.',
    popupBusy: 'Současně může být otevřeno pouze jedno okno přihlášení přes Google.',
    popupBlocked: 'Prohlížeč zablokoval okno Google. Povolte vyskakovací okna a zkuste to znovu.',
    unauthorizedDomain: 'Přihlášení přes Google zatím není povoleno pro tuto webovou adresu.',
    providerDisabled: 'Tento způsob přihlášení zatím není ve Fate Room povolen.',
    accountConflict: 'Tento e-mail už používá jiný způsob přihlášení. Nejprve se přihlaste heslem.',
  },
  es: {
    generic: 'Algo ha salido mal. Inténtalo de nuevo.',
    permission: 'Tu cuenta no tiene permiso para completar esta acción.',
    authentication: 'Vuelve a iniciar sesión para continuar.',
    network: 'La conexión se ha interrumpido. Comprueba internet e inténtalo de nuevo.',
    notFound: 'No se encontró la información solicitada.',
    storage: 'No se pudo subir el archivo. Comprueba la conexión e inténtalo de nuevo.',
    invalidCredential: 'El correo o la contraseña no son correctos.',
    accountNotFound: 'No existe una cuenta de Fate Room con este correo.',
    emailInUse: 'Este correo ya tiene una cuenta. Inicia sesión en su lugar.',
    weakPassword: 'Elige una contraseña de al menos 8 caracteres.',
    popupClosed: 'El acceso con Google se cerró antes de terminar.',
    popupBusy: 'Solo puede abrirse una ventana de acceso con Google a la vez.',
    popupBlocked: 'El navegador bloqueó la ventana de Google. Permite las ventanas emergentes e inténtalo de nuevo.',
    unauthorizedDomain: 'El acceso con Google aún no está habilitado para esta dirección web.',
    providerDisabled: 'Este método de acceso aún no está habilitado en Fate Room.',
    accountConflict: 'Este correo ya utiliza otro método de acceso. Inicia sesión primero con tu contraseña.',
  },
  pt: {
    generic: 'Ocorreu um problema. Tente novamente.',
    permission: 'A sua conta não tem permissão para concluir esta ação.',
    authentication: 'Inicie sessão novamente para continuar.',
    network: 'A ligação foi interrompida. Verifique a internet e tente novamente.',
    notFound: 'Não foi possível encontrar a informação pedida.',
    storage: 'Não foi possível carregar o ficheiro. Verifique a ligação e tente novamente.',
    invalidCredential: 'O e-mail ou a palavra-passe estão incorretos.',
    accountNotFound: 'Não existe uma conta Fate Room com este e-mail.',
    emailInUse: 'Este e-mail já tem uma conta. Inicie sessão em vez de criar outra.',
    weakPassword: 'Escolha uma palavra-passe com pelo menos 8 caracteres.',
    popupClosed: 'O início de sessão Google foi fechado antes de terminar.',
    popupBusy: 'Só pode estar aberta uma janela de início de sessão Google de cada vez.',
    popupBlocked: 'O navegador bloqueou a janela Google. Permita janelas pop-up e tente novamente.',
    unauthorizedDomain: 'O início de sessão Google ainda não está ativado para este endereço web.',
    providerDisabled: 'Este método de início de sessão ainda não está ativado no Fate Room.',
    accountConflict: 'Este e-mail já utiliza outro método de acesso. Inicie primeiro sessão com a palavra-passe.',
  },
};

const authCodes = {
  'auth/invalid-credential': 'invalidCredential',
  'auth/user-not-found': 'accountNotFound',
  'auth/wrong-password': 'invalidCredential',
  'auth/email-already-in-use': 'emailInUse',
  'auth/weak-password': 'weakPassword',
  'auth/popup-closed-by-user': 'popupClosed',
  'auth/cancelled-popup-request': 'popupBusy',
  'auth/popup-blocked': 'popupBlocked',
  'auth/unauthorized-domain': 'unauthorizedDomain',
  'auth/operation-not-allowed': 'providerDisabled',
  'auth/account-exists-with-different-credential': 'accountConflict',
};

export function isPermissionError(error) {
  const code = String(error?.code || '').toLowerCase();
  const message = String(error?.message || '').toLowerCase();
  return code.includes('permission-denied')
    || message.includes('missing or insufficient permissions')
    || message.includes('permission denied');
}

export function getLocalizedError(error, language = 'en', fallback = '') {
  const messages = copy[language] || copy.en;
  const code = String(error?.code || '').toLowerCase();
  const message = String(error?.message || '').toLowerCase();
  const authKey = authCodes[code];
  if (authKey) return messages[authKey];
  if (code.includes('permission-denied') || code.includes('unauthorized') || /insufficient permissions|permission denied/.test(message)) return messages.permission;
  if (code.includes('unauthenticated') || code.includes('user-token-expired')) return messages.authentication;
  if (code.includes('not-found')) return fallback || messages.notFound;
  if (code.includes('network') || code.includes('unavailable') || /network|offline|connection/.test(message)) return messages.network;
  if (code.startsWith('storage/')) return messages.storage;
  return fallback || messages.generic;
}
